export enum LoaderType {
  SMALL = 'small',
  MEDIUM = 'medium',
  FULL_SCREEN = 'full_screen',
}
export interface LoaderProps {
  type?: LoaderType;
}
